import { BergerLevrault, BergerlevraultLocalauthority } from "../../model";

export function isBergerLevrault(bergerLevrault: BergerLevrault): boolean {
	if (!bergerLevrault) return false
	return true
}

export function isBergerLevraultEnabled(bergerLevrault: BergerLevrault): boolean {
	if (isBergerLevrault(bergerLevrault) && bergerLevrault.enabled) return true
	if (isBergerLevrault(bergerLevrault) && !bergerLevrault.enabled) return false
}



// WEBPACK FOOTER //
// ./src/domain/sfp/berger-levrault-domain.ts